/*
 * Clix variant gallery fix
 *
 * Atlas updates the URL, price, SKU, and the <media-carousel> element's
 * media-id attribute when a variant is selected, but it does NOT re-render
 * the carousel's slide content. As a result the gallery keeps showing the
 * originally-loaded variant's image instead of the new one.
 *
 * This script watches for media-id changes on <media-carousel> and re-fetches
 * the product section from Shopify's Section Rendering API, then swaps the
 * carousel's slide content (and the thumbnail strip) with the freshly server-
 * rendered HTML. Server-side filtering via "only_selected_variant_images" is
 * already correct, so this just ensures the client picks up the new render.
 */
(function () {
  'use strict';

  function init() {
    var carousel = document.querySelector('media-carousel[data-section-ref="media-carousel"]');
    if (!carousel) return;

    var carouselId = carousel.id || '';
    var sectionId = carouselId.replace(/-media$/, '');
    if (!sectionId) return;

    var lastMediaId = carousel.getAttribute('media-id');
    var inFlight = null;

    function refreshGallery() {
      if (inFlight) inFlight.abort();
      inFlight = new AbortController();

      var sep = location.search ? '&' : '?';
      var url =
        location.pathname +
        location.search +
        sep +
        'section_id=' +
        encodeURIComponent(sectionId);

      return fetch(url, { signal: inFlight.signal, credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('Section fetch failed: ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCarousel = doc.querySelector(
            'media-carousel[data-section-ref="media-carousel"]'
          );
          if (!newCarousel) return;

          var currentInner = carousel.querySelector('.relative');
          var newInner = newCarousel.querySelector('.relative');
          if (currentInner && newInner) {
            currentInner.innerHTML = newInner.innerHTML;
          }

          var track = carousel.querySelector('[data-part="media-carousel-carousel"]');
          if (track && typeof track.scrollLeft === 'number') {
            track.scrollLeft = 0;
            track.scrollTop = 0;
          }

          var thumbStrips = document.querySelectorAll('media-carousel-thumbnails');
          var newThumbs = doc.querySelectorAll('media-carousel-thumbnails');
          thumbStrips.forEach(function (strip, idx) {
            var match = newThumbs[idx];
            if (match) strip.innerHTML = match.innerHTML;
          });

          lastMediaId = carousel.getAttribute('media-id');
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          console.error('[clix-variant-gallery-fix]', err);
        });
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName !== 'media-id') continue;
        var current = carousel.getAttribute('media-id');
        if (current && current !== lastMediaId) {
          lastMediaId = current;
          refreshGallery();
          return;
        }
      }
    });
    observer.observe(carousel, { attributes: true, attributeFilter: ['media-id'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
